import React, {useEffect, useState} from "react";

import {
    actions as opportunitiesActions,
    selectors as opportunitiesSelectors,
    selectors as opportunitySelectors
} from '../../../Ducks/opportunity';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import Calendar from "../Calendar/Widgets/CalendarWidget/Calendar";
import {selectors as accountSelectors} from "../../../Ducks/account";
import {CircularProgress} from "@mui/material";
import {getWeekStartEndDate} from "../../Utils/dateUtils";


function SaleCalendar(props) {
    const {events, calendar, followUps, getAllEvents, getAllEvents_loading, cronofyAuthorized} = props;
    const [legacyEvents, setLegacyEvents] = useState([]);
    const [legacyFollowUps, setLegacyFollowUps] = useState([]);

    useEffect(() => {
        renderCalendarData()
    }, []);

    const renderCalendarData = () => {
        getAllEvents(getWeekStartEndDate(new Date()));
    }

    useEffect(() => {
        if (calendar) {
            if (Array.isArray(calendar)) {
                setLegacyEvents(calendar);
            } else if (calendar) {
                setLegacyEvents([calendar]);
            }
        }
    }, [calendar]);

    useEffect(() => {
        if (followUps) {
            if (Array.isArray(followUps)) {
                setLegacyFollowUps(followUps);
            } else if (followUps) {
                setLegacyFollowUps([followUps]);
            }
        }
    }, [followUps]);

    return (
        <>
            {
                (getAllEvents_loading) ? <CircularProgress/> :
                    (
                        <Calendar {...props} events={cronofyAuthorized ? events : []}
                                  legacy_events={legacyEvents} follow_ups={legacyFollowUps}/>
                    )
            }
        </>
    );
}


const mapStateToProps = (state) => ({
    calendar: opportunitySelectors.calendar(state),
    events: opportunitySelectors.events(state),
    followUps: opportunitySelectors.followUps(state),
    getAllEvents_loading: opportunitiesSelectors.getAllEvents_loading(state),
    cronofyAuthorized: accountSelectors.cronofyAuthorized(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getAllEvents: opportunitiesActions.getAllEvents,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SaleCalendar);
